import { ContextVoter } from "./composables/ContextVoter";

/** Mirrors the API client (organisation) security. */
export class ClientVoter extends ContextVoter {
  /** POST /clients requires ClientAttribute::CREATE, the global client create right. */
  public canCreate(): boolean {
    return this.canCreateClientContext();
  }
}
